import Vue from "vue";

import IconDropdown from "./UI/IconDropdown.vue";
import Icon from "./UI/Icon.vue";
import IconBtn from "./UI/IconBtn.vue";
import IconLinkBtn from "./UI/IconLinkBtn.vue";
import Spinner from "./UI/Spinner.vue";
import Btn from "./UI/Btn.vue";
import DropdownButton from "./UI/DropdownButton.vue";
import ImportExport from "./UI/ImportExport.vue";
import LinkBtn from "./UI/LinkBtn.vue";
import Card from "./UI/Card.vue";
import CardTitle from "./UI/CardTitle.vue";
import CardValue from "./UI/CardValue.vue";
import Tag from "./UI/Tag.vue";
import Badge from "./UI/Badge.vue";
import Field from "./UI/Field.vue";
import VatField from "./UI/VatField.vue";
import InputGroup from "./UI/InputGroup.vue";
import FileField from "./UI/FileField.vue";
import TextareaField from "./UI/TextareaField.vue";
import DatepickerField from "./UI/DatepickerField.vue";
import Checkbox from "./UI/Checkbox.vue";
import SelectField from "./UI/SelectField.vue";
import Dropdown from "./UI/Dropdown.vue";
import Alert from "./UI/Alert.vue";
import ObjectLink from "./UI/ObjectLink.vue";
import ObjectButton from "./UI/ObjectButton.vue";
import UpgradeInactiveModal from "./components/UpgradeInactiveModal";

Vue.component("icon-dropdown", IconDropdown);
Vue.component("icon-btn", IconBtn);
Vue.component("icon-link-btn", IconLinkBtn);
Vue.component("icon", Icon);
Vue.component("btn", Btn);
Vue.component("dropdown-btn", DropdownButton);
Vue.component("import-export", ImportExport);
Vue.component("link-btn", LinkBtn);
Vue.component("spinner", Spinner);
Vue.component("card", Card);
Vue.component("card-title", CardTitle);
Vue.component("card-value", CardValue);
Vue.component("tag", Tag);
Vue.component("badge", Badge);
Vue.component("input-group", InputGroup);
Vue.component("field", Field);
Vue.component("vat-field", VatField);
Vue.component("file-field", FileField);
Vue.component("textarea-field", TextareaField);
Vue.component("datepicker-field", DatepickerField);
Vue.component("select-field", SelectField);
Vue.component("dropdown", Dropdown);
Vue.component("checkbox", Checkbox);
Vue.component("alert", Alert);
Vue.component("object-link", ObjectLink);
Vue.component("object-button", ObjectButton);
Vue.component("upgrade-inactive-modal", UpgradeInactiveModal);

new Vue({
	el: "#app",

	data: {
		is_loading: false,
		has_loaded_first: false,
	},

	methods: {
		addUpgradeModal() {
			const modal = new window.Modal("upgrade-inactive-modal");
			window.modal_store.commit("addModal", modal);
		},
	},
});
